var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav', {
    staticClass: "navbar navbar-expand-lg mx-0 align-items-center d-flex justify-content-between fixed-top custom-nav sticky-header",
    attrs: {
      "bg-variant": "dark"
    }
  }, [_c('div', {
    staticClass: "w-100 mx-1 mx-lg-5 mx-xl-5 py-1 align-items-center d-flex justify-content-center justify-content-lg-between justify-content-xl-between",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "header_btn"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-backdrop",
      modifiers: {
        "sidebar-backdrop": true
      }
    }],
    staticClass: "navbar-toggler ml-2 p-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showMobileMenu
    }
  }, [_c('i', {
    class: {
      'mdi mdi-menu': !_vm.isMobileMenuOpened,
      'mdi mdi-close': _vm.isMobileMenuOpened
    }
  })])]), _c('router-link', {
    staticClass: "navbar-brand brand-logo mr-0 mr-lg-4 mr-xl-4 mx-sm-auto",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "img-fluid logo-small-screen",
    attrs: {
      "src": require("@assetsImages/logo/PSHeaderLogo.svg"),
      "alt": ""
    },
    on: {
      "click": _vm.pslogoClickHandler
    }
  }), _c('img', {
    staticClass: "img-fluid logo-dark",
    attrs: {
      "src": require("@assetsImages/logo/PSHeaderLogo.svg"),
      "alt": ""
    },
    on: {
      "click": _vm.pslogoClickHandler
    }
  })]), _c('div', {
    staticClass: "navbar-collapse collapse justify-content-end",
    attrs: {
      "id": "navbarCollapse"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav navbar-center",
    attrs: {
      "id": "mySidenav"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link menu-item",
    attrs: {
      "name": "Cyber Corner",
      "href": "/#/cyber-corner"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.menuItemAnchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v(" Cyber Corner ")])]), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle menu-item",
    attrs: {
      "name": "Courses/Videos",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Courses/Videos")]), _c('ul', {
    staticClass: "nav-bar submenu dropdown-menu list-unstyled p-0"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/online-courses"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Online Courses")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/information-videos"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Informational Videos")])])])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link menu-item",
    attrs: {
      "name": "Events",
      "href": "/#/events"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.menuItemAnchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v(" Events ")])]), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle menu-item",
    attrs: {
      "name": "Info Hub",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Info Hub")]), _c('ul', {
    staticClass: "nav-bar submenu dropdown-menu list-unstyled p-0"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/white-papers"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("White Papers")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/policy-corner"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Policy Corner")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/client-templates"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Client Templates")])])])]), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle menu-item",
    attrs: {
      "name": "Resources",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Useful Tools")]), _c('ul', {
    staticClass: "nav-bar submenu dropdown-menu list-unstyled p-0"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/cyber-readiness-check"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Cyber Self Assessments")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/tool-list"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Products & Services")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/useful-links"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Useful Links & Resources")])])])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link menu-item",
    attrs: {
      "name": "Speaker Request",
      "href": "/#/speaker-request"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.menuItemAnchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Speaker Request")])]), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link menu-item",
    attrs: {
      "name": "Sign In/Register",
      "data-toggle": "dropdown",
      "href": !_vm.isLoggedIn && '/#/login'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        !_vm.isLoggedIn && function (e) {
          return _vm.menuItemAnchorTagClickHandler(e);
        };
      }
    }
  }, [_vm._v(_vm._s(_vm.loginMenuTabTitle))]), _vm.isLoggedIn ? _c('ul', {
    staticClass: "nav-bar submenu dropdown-menu list-unstyled p-0"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/my-account"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("User Profile")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/dashboard"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("My Dashboard ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#/logout"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function (e) {
          return _vm.anchorTagClickHandler(e);
        }.apply(null, arguments);
      }
    }
  }, [_vm._v("Logout")])])]) : _vm._e()])]), _vm._m(0)])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "menu-close-btn"
  }, [_c('i', {
    staticClass: "mdi mdi-close-circle-outline"
  })]);

}]

export { render, staticRenderFns }